import { LucideIcon } from 'lucide-react';
import { Users, LayoutDashboard } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon?: LucideIcon;
  children?: NavItem[];
  roles?: string[];
}

export const mainNavigation: NavItem[] = [
  {
    to: '/naboen',
    label: 'Naboen'
  },
  {
    to: '/min-bolig',
    label: 'Min bolig',
    roles: ['owner', 'tenant', 'board']
  },
  {
    to: '/bofellesskapet',
    label: 'Bofellesskapet',
    roles: ['owner', 'tenant', 'board']
  },
  {
    to: '/reservasjoner',
    label: 'Reservasjoner',
    roles: ['owner', 'tenant', 'board']
  },
  {
    to: '/styret',
    label: 'Styret',
    icon: Users,
    roles: ['board']
    // Children genereres dynamisk fra getStyretNavItems() i Sidebar.tsx
  },
  {
    to: '/admin',
    label: 'Admin',
    icon: LayoutDashboard,
    roles: ['admin']
    // Children genereres dynamisk fra getAdminNavItems() i Sidebar.tsx
  }
];

export const supportNavigation: NavItem[] = [
  {
    to: '/kontakt',
    label: 'Meldinger'
  },
  {
    to: '/profil',
    label: 'Profil'
  },
  {
    to: '/om-oss',
    label: 'Om oss'
  },
  {
    to: '/faq',
    label: 'Hjelpesenter'
  },
  {
    to: '/rapporter',
    label: 'Rapportering',
    roles: ['admin', 'board']
  },
  {
    to: '/produktutvikling',
    label: 'Produktutvikling',
    roles: ['admin', 'board']
  }
];